import * as globalStore from '@store/index'
export const state = () => globalStore.state()
export const mutations = globalStore.mutations
export const actions = globalStore.actions
